import { ChangeEvent } from 'react';
import { TextField } from '@mui/material';

interface CustomTextFieldProps {
    label: string;
    placeholder?: string;
    name: string;
    value: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    multiline?: boolean;
    rows?: number;
    fullWidth?: boolean;
    className?: string;
    onPaste?: (event: React.ClipboardEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

export function CustomTextField({
    label,
    placeholder,
    name,
    value,
    onChange,
    multiline = false,
    rows = 1,
    fullWidth = false,
    className,
    onPaste,
}: CustomTextFieldProps) {
    return (
        <TextField
            className={className}
            label={label}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            onPaste={onPaste as unknown as React.ClipboardEventHandler<HTMLDivElement>}
            multiline={multiline}
            rows={rows}
            fullWidth={fullWidth}
            InputLabelProps={{
                shrink: true,
                style: {
                    paddingRight: "5px",
                    paddingLeft: "5px",
                },
            }}
        />
    );
}
